export enum QUOTE_STATUS {
  IN_PROGRESS = 'in_progress',
  PAID = 'paid',
  ISSUED = 'issued',
  REFUNDED = 'refunded',
  ARCHIVED = 'archived',
  CANCELED = 'canceled',
}

export enum QUOTE_SUB_STATUS {
  EMPTY = '',
  PENDING_QUOTATION = 'pending_quotation',
  PENDING_PRODUCT_SELECTION = 'pending_product_selection',
  PENDING_PAYMENT_DETAILS = 'pending_payment_details',
  PENDING_CUSTOMER_PAYMENT = 'pending_customer_payment',
  PENDING_CUSTOMER_DETAILS = 'pending_customer_details',
  PENDING_DETAILS = 'pending_details',
  INVITED = 'invited',
  INVITE_OPENED = 'invite_opened',
  PLAN_SELECTED = 'plan_selected',
}

export enum ORDER_STATUS {
  ORDER_PENDING = 'order.pending',
  ORDER_COMPLETED = 'order.completed',
}
